import { createFileRoute } from '@tanstack/react-router';
import { UsersClient } from '@/features/users/UsersClient';

export const Route = createFileRoute('/_shell/users/')({
  component: UsersClient,
});
